import { type PlatformBankAccountForm } from "@zhihaoscm/entity";
import { TRADE_PRODUCT_PAY_TYPE } from "@zhihaoscm/meta";
import { DEFAULT_VALUE } from "@/config";

// 线上收款账号信息  暂时写死
export const onlineBankAccount: PlatformBankAccountForm = {
    name: "志豪链云科技有限公司",
    account: "42050167763800000789",
    openingBank: "中国建设银行股份有限公司黄冈城东支行",
    isOwnAccount: 1,
    supportOnline: 1
};

// 处理支付方式
export const handlePayType = (payTypes: number[]) => {
    let _type;
    // 1线上支付 2线下支付 3线上和线下支付
    if (payTypes?.length === 1) {
        _type = payTypes[0];
    } else if (payTypes?.length === 2) {
        _type = TRADE_PRODUCT_PAY_TYPE.ONLINE_AND_OFFLINE.code;
    }
    return _type;
};

// 处理银行账户表单
export const handleBankAccountForm = (type: number, form: PlatformBankAccountForm[] = []) => {
    let _form = undefined;
    // 用户选择的方式包含线下支付，则收集用户选择的银行账户
    if ([TRADE_PRODUCT_PAY_TYPE.OFFLINE.code,TRADE_PRODUCT_PAY_TYPE.ONLINE_AND_OFFLINE.code].includes(type)) {
        _form = [...form].length ? [...form] : [{}];
    }
    return _form;
};

//格式化银行账号
export const formatBankAccount = (account?: string) => {
    if (!account) return DEFAULT_VALUE;
    // 前3位后加空格，后面每4位字符后加一个空格
    let str = "";
    for (let i = 0; i < account.length; i++) {
        str += account[i];
        // 检查是否是第4位、第8位、第12位等（即4的倍数位）
        if ((i + 1) % 4 === 0 && i !== account.length) {
            str += " ";
        }
    }
    return str.trimEnd();
};
